package com.example.mystybag.appCore.model.pages

data class CompanyResponsiblePersonsListUIState(
    val persons: List<CompanyResponsiblePerson> = emptyList(),
    val isLoading: Boolean = false
)
